<template>
  <div id="app">
    <IndexPage />
  </div>
</template>

<script>
import IndexPage from './pages/IndexPage.vue'

export default {
  name: 'App',
  components: {
    IndexPage
  }
}
</script>
